module.exports = __webpack_public_path__ + "static/img/68.9732e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/68.png
// module id = KRRr
// module chunks = 0